import { DatePipe } from '@angular/common';
import { Component, Injector } from '@angular/core';
import { RecursoService } from 'administrativo-lib';
import {
  BaseResourceListComponent, Coluna, DateFormatPipe, Filtro, FormatoExportacao,
  GlobalService, LoginContabil, Recebimento, Recurso
} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RecebimentoService } from '../service/recebimento.service';

@Component({
  selector: 'app-recebimento-list',
  templateUrl: './recebimento-list.component.html'
})

export class RecebimentoListComponent extends BaseResourceListComponent<Recebimento, LoginContabil> {
  /**
   * Declaração de variáveis
   */
  public especieSelect = 'REO';
  public listaEspecies: Array<any>;
  public ptBR: any;
  public datepipe: DatePipe;
  public data1: Date;
  public data2: Date;
  public listaRecursos: Array<Recurso>;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private globalService: GlobalService,
    private recebimentoService: RecebimentoService,
    protected recursoServico: RecursoService) {
    super(recebimentoService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected podeAlterar(item: Recebimento): boolean {
    return this.login.sistema != 'controle-interno'
  }
  
  protected relations(): string {
    return 'conta,conta.banco,ficha,ficha.receita,ficha.recurso,ficha.aplicacao,exercicio,orgao';
  }

  protected condicoesGrid(): {} {
    const parametros = {};
    this.datepipe = new DatePipe('pt');
    parametros['ignoreCondObrig'] = true;
    parametros['data_recebimento$ge'] = this.datepipe.transform(this.data1, 'yyyy-MM-dd');
    parametros['data_recebimento$le'] = this.datepipe.transform(this.data2, 'yyyy-MM-dd');
    parametros['orgao.id'] = this.login.orgao.id;
    parametros['exercicio.id'] = this.login.exercicio.id

    sessionStorage.removeItem('/recebimentos_data1');
    sessionStorage.removeItem('/recebimentos_data2');

    return parametros;
  }

  protected ordenacaoGrid(): string[] {
    return ['data_recebimento$DESC', 'id$DESC'];
  }

  protected filtrosGrid(): Filtro {
    return {
      date: ['data_recebimento'],
      number: ['ficha.receita.codigo', 'valor_recebido', 'ficha.numero'],
      text: ['ficha.receita.nome', 'conta.agencia', 'conta.numero_conta', 'conta.banco.nome', 'conta.nome', 'ficha.recurso.codigo', 'ficha.aplicacao.codigo']
    };
  }

  public beforeInit(): void {
    this.ptBR = this.globalService.obterDataBR();
    this.datepipe = new DatePipe('pt');
    const dt1: string = sessionStorage.getItem('/recebimentos_data1');
    const dt2: string = sessionStorage.getItem('/recebimentos_data2');
    this.usarFiltroPersonalizado = true;

    if (!dt1) {
      this.data1 = new DateFormatPipe().transform(this.datepipe.transform(new Date(`01/01/${this.login.exercicio.ano}`), 'yyyy-MM-dd'), []);
    } else {
      this.data1 = new DateFormatPipe().transform(dt1, []);
    }
    if (!dt2) {
      this.data2 = new DateFormatPipe().transform(this.datepipe.transform(new Date(), 'yyyy-MM-dd'), []);
    } else {
      this.data2 = new DateFormatPipe().transform(dt2, []);
    }
  }

  protected afterInit(): void {
    this.listaEspecies = [
      { id: 'REO', nome: 'ORÇAMENTÁRIA' },
      { id: 'REE', nome: 'EXTRA-ORÇAMENTARIA' }
    ];
  }

  protected acaoRemover(model: Recebimento): Observable<Recebimento> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Data', coluna: 'data_recebimento' },
      { titulo: 'Ficha Nº', coluna: 'ficha.numero' },
      { titulo: 'Descrição', coluna: 'ficha.receita.nome' },
      { titulo: 'Agência nome', coluna: 'conta.agencia_nome' },
      { titulo: 'Número conta', coluna: 'conta.numero_conta' },
      { titulo: 'Valor', coluna: 'valor_recebido', decimais: 2, alignment: 'right' }
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    parametros['relations'] = 'conta,ficha,ficha.receita,exercicio,orgao';
    this.recebimentoService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          if (formato === 'pdf') {
            this.imprimir('LISTAGEM DE RECEBIMENTOS ORÇAMENTÁRIOS',
              this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao, 'portrait',
              'Listagem recebimentos', ['auto', 'auto', '*', 'auto', 'auto', 'auto'], lista.content, ['valor_recebido']);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        () => alert('erro ao retornar lista')
      );
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  onChangeRecebimento(value: any, especie: any) {
    if (especie === 'REE') {
      this.router.navigate(['recebimentos-extras']);
    }
  }

  public voltar() {
    if (this.login.sistema === 'contabil') {
      this.router.navigate(['/tesouraria']);
    } else {
      this.sair();
    }
  }

  public obterColunasFiltroPersonalizado(): Coluna[] {
    const retorno: Coluna[] = [];
    retorno.push({ titulo: 'Data Recebimento', coluna: 'data_recebimento', tipo: 'Date', alignment: 'center', padrao: true, filtro2: new Date() });
    retorno.push({ titulo: 'Nº Ficha', coluna: 'ficha.numero', tipo: 'Number', padrao: true, cols: 3 });
    retorno.push({ titulo: 'Código da Receita', coluna: 'ficha.receita.codigo', tipo: 'Number', padrao: true, cols: 3 });
    retorno.push({ titulo: 'Valor', coluna: 'valor_recebido', tipo: 'Number', padrao: false, cols: 3 });
    retorno.push({ titulo: 'Guia', coluna: 'guia', tipo: 'String', cols: 3 });
    retorno.push({ titulo: 'Descricao', coluna: 'ficha.receita.nome', tipo: 'String', cols: 3 });
    retorno.push({ titulo: 'Número Conta', coluna: 'conta.numero_conta', tipo: 'String', cols: 3 });
    retorno.push({ titulo: 'Histórico', coluna: 'historico', tipo: 'String', cols: 3 });
    retorno.push({ titulo: 'Id. Conta', coluna: 'conta.codigo', tipo: 'String', cols: 3 });
    retorno.push({ titulo: 'Código da Espécie', coluna: 'especie', tipo: 'String', cols: 3 });
    retorno.push({ titulo: 'Recurso', coluna: 'ficha.recurso.codigo', tipo: 'String', cols: 3 });
    retorno.push({ titulo: 'Aplicação', coluna: 'ficha.aplicacao.codigo', tipo: 'String', cols: 3 });
    retorno.push({ titulo: 'Aplicação Variável', coluna: 'ficha.aplicacao_variavel.variavel', tipo: 'String', cols: 3 });
    return retorno;
  }
}
